import { render } from "./ModalSelectItemCombo.vue?vue&type=template&id=4b549836&scoped=true"
import script from "./ModalSelectItemCombo.vue?vue&type=script&lang=js"
export * from "./ModalSelectItemCombo.vue?vue&type=script&lang=js"

import "./ModalSelectItemCombo.vue?vue&type=style&index=0&id=4b549836&scoped=true&lang=css"

import exportComponent from "/var/www/html/minty.crm.frontend.merchant/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b549836"]])

export default __exports__